import { takeEvery, put, call, select } from 'redux-saga/effects';
import { all } from 'typed-redux-saga';

import { signalRActions } from '@crm-framework/signalr';
import { createFavicon } from '@crm-framework/utils';
import { apiGetUser, authSetUser } from '@crm-framework/auth';

import {
  APP_START_INIT,
  appFinishInit,
  appUnavailable,
  appUnauthorized,
  appSetConfig,
} from './reducer';
import { apiGetAppConfig } from './api';
import { getAppState } from './selector';

export function* watchApp() {
  yield takeEvery(APP_START_INIT, handleStartInit);
}

function* handleStartInit() {
  try {
    const { appConfig, user } = yield* all({
      appConfig: call(apiGetAppConfig),
      user: call(apiGetUser),
    });

    if (!user.isAuthenticated) {
      yield call(handleUnauthorized);

      return;
    }

    yield createFavicon(appConfig.faviconDefaultUrl);
    yield put(appSetConfig(appConfig));
    yield put(authSetUser(user));
    yield put(signalRActions.connect());
    yield put(appFinishInit());
  } catch (e) {
    if (e.status === 401) {
      yield call(handleUnauthorized);

      return;
    }

    yield put(appUnavailable());
  }
}

function* handleUnauthorized() {
  try {
    const { isLoginRedirect } = yield select(getAppState);

    if (isLoginRedirect) {
      const returnUrl = encodeURIComponent(
        window.location.pathname + window.location.search
      );
      const loginUrl = `/login?returnUrl=${returnUrl}`;

      window.location.replace(loginUrl);

      return;
    }

    yield put(appUnauthorized());
  } catch (e) {
    console.error(e);
  }
}
